'use strict';

/**
 * creates a swiper instance and removes it at a given breakpoint
 */
class responsiveSwiper {

    /**
     * @param parameters
     */
    constructor(parameters) {
        let self = this;

        // param defaults
        this._swiper = null;
        this._element = parameters.element;
        this._breakPoint = parameters.breakPoint;
        this._swiperOptions = parameters.swiperOptions || {
            loop: false,
            direction: 'horizontal',
            observer: true,
            observeParents: true,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        };

        // initial check
        self._checkForCondition();

        // event listener
        window.addEventListener('resize', () => {
            self._checkForCondition();
        });
    }

    /**
     * @private
     */
    _checkForCondition() {
        if (window.innerWidth <= this._breakPoint
            && this._swiper === null) {
            this._initSwiper();
        }
        if (window.innerWidth > this._breakPoint
            && this._swiper !== null) {
            this._destroySwiper();
        }
    }

    /**
     * @private
     */
    _initSwiper() {
        this._swiper = new Swiper(this._element, this._swiperOptions);
    }

    /**
     * @private
     */
    _destroySwiper() {
        if (this._swiper && this._swiper.el && this._swiper.el.length) {
            this._swiper.destroy(true, true); 
            this._swiper = null;
        }
    }
}
